export default "__VITE_ASSET__cf702a22__"